import { Badge } from "@mantine/core";

import { env } from "@/config";

import { useRealtimeWebsocketStore } from "./realtimeWebsocketStore";
import classes from "./SimplrWebsocketBadge.module.css";

/**
 * Visible indicator shown in the expert-assist timeline while the live realtime websocket is routed
 * to Simplr (the `isSimplrWebsocketLiveEnabled` Staples cutover) instead of GAIA. Present in the DOM,
 * it lets FullStory session replay show at a glance that a given Staples call was actually served by
 * Simplr — the frontend is otherwise identical for either provider. Renders nothing on GAIA.
 *
 * Hidden in production: real experts shouldn't see an internal routing indicator during live calls.
 * `useReportRealtimeWebsocket`'s EDP analytic, FullStory property, and FullStory event are unaffected
 * by this and keep firing in every environment, so the prod pilot stays observable without the pill.
 */
export function SimplrWebsocketBadge() {
    const provider = useRealtimeWebsocketStore((state) => state.provider);

    if (provider !== "simplr" || env.isProdMode) return null;

    return (
        <Badge
            color="grape"
            variant="filled"
            radius="sm"
            size="sm"
            classNames={{ root: classes.badge }}
            data-testid="simplr-websocket-badge"
            data-realtime-provider="simplr"
            aria-label="Live realtime websocket: Simplr"
        >
            Simplr live
        </Badge>
    );
}
